import { FC, useState } from 'react';
import { StaticInput } from '../shared/static-input/static-input';
import { Button } from '../shared/button/button';
import { QuoteForm } from '../quote-form/quote-form';
import { formatValueToString } from '../../helpers';
import { PrintedPageData } from '../../types';

import './footer.css';

type Props = {
  setShowSuccess: (show: boolean) => void;
  onePrice: number;
  totalPrice: number;
  colorsCount: number;
  listsCount: number;
  barcode: number;
  quantity: number;
  printedPagesData: PrintedPageData[];
}

export const Footer: FC<Props> = ({
  setShowSuccess,
  onePrice,
  totalPrice,
  colorsCount,
  barcode,
  listsCount,
  quantity,
  printedPagesData,
}) => {
  const [openForm, setOpenForm] = useState<boolean>(false);

  const getFormattedValue = (value: number) => {
    let formattedValue = formatValueToString(value);

    if (!formattedValue.split(',')[1]) {
      formattedValue = `${formattedValue},00`;
    }

    if (formattedValue.split(',')[1].length === 1) {
      formattedValue = `${formattedValue}0`;
    }

    return formattedValue;
  };

  return (
    <div className="container-footer">
      <div>
        <div className="container-footer-item">
          <span>Стоимость руб./ за 1 бланк в т.ч. НДС20%</span>
          <StaticInput value={getFormattedValue(onePrice)} />
        </div>
        <div className="container-footer-item">
          <span>Итого руб. в т.ч. НДС20%</span>
          <StaticInput value={getFormattedValue(totalPrice)} />
        </div>
        <Button
          text="Отправить стоимость на почту"
          onClick={() => setOpenForm(true)}
        />
      </div>
      {openForm && (
        <QuoteForm
          setOpenForm={setOpenForm}
          setShowSuccess={setShowSuccess}
          totalPrice={totalPrice}
          onePrice={getFormattedValue(onePrice)}
          quantity={quantity}
          colorsCount={colorsCount}
          barcode={barcode}
          listsCount={listsCount}
          printedPagesData={printedPagesData}
        />
      )}
    </div>
  );
};